import gql from 'graphql-tag'
import {
	articlesByEntityResults,
	standardArticleResult,
	articleConnectionData,
} from 'store/fragments'

// Mutations
//todo remaning
export const CreateArticleMutation = gql`
	mutation handleArticle(
		$articleId: String!
		$userId: String!
		$companyId: String!
		$teamId: String!
		$postAs: String!
		$title: String!
		$description: String!
		$body: String!
		$imageId: String!
		$images: [ImageInsertInput!]!
	) {
		insertIntoImageCollection(objects: $images) {
			affectedCount
			records {
				id
				title
			}
		}

		updateArticleCollection(
			filter: { id: { eq: $articleId }, user: { eq: $userId } }
			set: {
				readDuration: 12
				postingCompany: $companyId
				isFeatured: false
				postingTeam: $teamId
				postAs: $postAs
				title: $title
				isPost: true
				description: $description
				body: $body
				featuredImage: $imageId
			}
		) {
			affectedCount
			records {
				...standardArticleResult
			}
		}
	}
	${standardArticleResult}
`

export const DeleteArticleMutation = gql`
	mutation deleteArticle($id: String!) {
		deleteFromArticleCollection(filter: { id: { eq: $id } }) {
			records {
				...standardArticleResult
			}
		}
	}
	${standardArticleResult}
`

export const ArticlesByEntity = gql`
	query articlesByEntity(
		# $language: LanguageCodeType!
		$userId: String
		$companyId: String
		$teamId: String
	) {
		feedArticles(
			userid: $userId
			companyid: $companyId
			teamid: $teamId # language: $language
		) {
			edges {
				node {
					...articlesByEntityResults
				}
			}
		}
	}
	${articlesByEntityResults}
`
//todo remaning
export const Article = gql`
	query article($id: String, $slug: String) {
		feedArticles(filter: { id: { eq: $id }, slug: { ilike: $slug } }) {
			edges {
				node {
					...standardArticleResult
				}
			}
		}
	}
	${standardArticleResult}
`

export const FeedArticlesQuery = gql`
	query feedArticles(
		$userid: String
		# $useruid: String
		$companyslug: String
		$teamid: String
		$first: Int
		$after: Cursor
	) {
		feedArticles(
			userid: $userid
			# useruid: $useruid
			companyslug: $companyslug
			teamid: $teamid
			first: $first
			after: $after
		) {
			...articleConnectionData
		}
	}
	${articleConnectionData}
`
export const FeedTeamArticlesQuery = gql`
	query feedTeamArticles($teamId: String!, $first: Int!, $after: Cursor) {
		feed_team_articles(
			team_id: $teamId
			limit_count: $first
			after: $after
		) {
			...articleConnectionData
		}
	}
	${articleConnectionData}
`

export const ArticleTagVotersQuery = gql`
	query getArticleTagVoters($articleId: String!) {
		activeArticleTagCollection(filter: { article: { eq: $articleId } }) {
			edges {
				node {
					articleTag {
						id
						title
					}
					_ActiveArticleTagToUserCollection {
						edges {
							node {
								user {
									id
									uid
									profileCollection {
										edges {
											node {
												id

												firstName
												lastName
												avatarPath
												experienceCollection {
													edges {
														node {
															position
															company
														}
													}
												}
												# worksAt {
												# 	id
												# 	company
												# 	position
												# }
											}
										}
									}
								}
								activeArticleTag {
									votes
									tag
									articleTag {
										id
										title
									}
									article {
										id
										title
										slug
									}
								}
							}
						}
					}
				}
			}
		}
	}
`
